import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "../components/layout/SiteChrome";
import { request } from "../services/api";
import { imageUrl } from "../services/config";

type Category = { _id: string; name: string; icon: string; description: string; image?: { url: string } };

export default function SellPage() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    request('/categories').then(data => setCategories(data.categories || [])).catch(console.error);
  }, []);

  const filtered = categories.filter(c => (c.name || "").toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className="page-bg">
      <Header />
      <section style={{ background: "var(--indigo)", padding: "44px 20px 40px" }}>
        <div style={{ maxWidth: 1160, margin: "0 auto" }}>
          <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, color: "rgba(255,255,255,0.55)", textDecoration: "none", marginBottom: 18, transition: "color 0.2s" }}
            onMouseEnter={e => (e.currentTarget.style.color = "#fff")} onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}>
            ← Back to Home
          </Link>
          <div style={{ marginBottom: 20 }}>
            <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(24px,4vw,34px)", color: "#fff", letterSpacing: "-0.5px" }}>What are you looking to sell?</h1>
            <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 14, marginTop: 4 }}>Select a category to get an instant price</p>
          </div>
          <div className="banner-search">
            <span className="banner-search__icon">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="var(--indigo)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </span>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search category..."
              style={{ color: "var(--text)" }} />
            {q && (
              <button type="button" onClick={() => setQ("")} className="banner-search__clear" aria-label="Clear search">✕</button>
            )}
          </div>
        </div>
      </section>

      <section style={{ maxWidth: 1160, margin: "0 auto", padding: "44px 20px 64px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 12 }}>
          {filtered.map((c, i) => (
            <CategoryCard key={c._id} c={c} delay={i * 60} />
          ))}
        </div>
        {filtered.length === 0 && (
          <div style={{ textAlign: "center", padding: "72px 0", color: "var(--text2)" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
            <p style={{ fontSize: 15 }}>No categories found for "{q}"</p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}

function CategoryCard({ c, delay }: { c: Category; delay: number }) {
  const [hov, setHov] = useState(false);
  return (
    <Link to={`/category/${c._id}`}
      className="animate-fade-up"
      style={{ animationDelay: `${delay}ms`, display: "block", textDecoration: "none" }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{
        background: "var(--surface)",
        border: hov ? "1.5px solid var(--brand)" : "1.5px solid var(--border)",
        borderRadius: 14, padding: "18px 14px 16px", textAlign: "center",
        transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
        transform: hov ? "translateY(-4px)" : "none",
        boxShadow: hov ? "0 8px 24px rgba(255,107,53,0.12)" : "var(--shadow-sm)",
        cursor: "pointer", height: "100%",
      }}>
        <div style={{ height: 56, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
          {c.image?.url ? (
            <img src={imageUrl(c.image.url)} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
          ) : (
            <span style={{ fontSize: 40 }}>{c.icon}</span>
          )}
        </div>
        <h3 style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, color: "var(--text)" }}>{c.name}</h3>
      </div>
    </Link>
  );
}